import { useState } from 'react';
import styles from './ProtocolRow.module.css';

const OVERFLOW_THRESHOLD = 4; // Collapse when more than this many blocks

function ProtocolRow({ protocol, blocks, hasRegions, onEditProtocol, onAddBlock, onEditBlock, onDeleteProtocol }) {
    const [expanded, setExpanded] = useState(false);

    const blockCount = blocks.length;
    const shouldCollapse = blockCount > OVERFLOW_THRESHOLD;
    const isCollapsed = shouldCollapse && !expanded;

    return (
        <div className={styles.row}>
            <div className={styles.header}>
                <div className={styles.titleRow}>
                    <h4 className={styles.protocolName}>{protocol.name}</h4>
                    <div className={styles.actions}>
                        <button
                            type="button"
                            className={styles.editButton}
                            onClick={() => onEditProtocol(protocol)}
                        >
                            Edit
                        </button>
                        <button
                            type="button"
                            className={styles.addBlockButton}
                            onClick={() => onAddBlock(protocol)}
                            disabled={!hasRegions}
                            title={!hasRegions ? 'Create at least one region definition first' : 'Add block to this protocol'}
                        >
                            + Add block
                        </button>
                        {onDeleteProtocol && (
                            <button
                                type="button"
                                className={styles.deleteButton}
                                onClick={() => {
                                    if (window.confirm(`Delete protocol "${protocol.name}"? This will also delete all blocks in this protocol and their region data. This cannot be undone.`)) {
                                        onDeleteProtocol(protocol);
                                    }
                                }}
                                title="Delete this protocol and all its blocks"
                            >
                                Delete
                            </button>
                        )}
                    </div>
                </div>
                {protocol.description && (
                    <p className={styles.description}>{protocol.description}</p>
                )}
            </div>

            <div
                className={`${styles.blockCardsWrap} ${isCollapsed ? styles.collapsed : ''}`}
                id={`protocol-blocks-${protocol._id}`}
            >
                {blocks.length === 0 ? (
                    <div className={styles.emptyBlocks}>
                        <p>No blocks in this protocol.</p>
                        <button
                            type="button"
                            className={styles.addBlockButtonInline}
                            onClick={() => onAddBlock(protocol)}
                            disabled={!hasRegions}
                        >
                            Add block
                        </button>
                    </div>
                ) : (
                    <div className={styles.blockCards}>
                        {blocks.map((block) => (
                            <button
                                key={block._id}
                                type="button"
                                className={styles.blockCard}
                                onClick={() => onEditBlock(block)}
                            >
                                <span className={styles.blockCardName}>{block.name}</span>
                                <span className={styles.blockCardMeta}>
                                    {Array.isArray(block.regionDefinitions) && block.regionDefinitions.length > 0
                                        ? block.regionDefinitions.map(r => r.displayName || r.abbreviation).join(', ')
                                        : 'No regions'}
                                </span>
                            </button>
                        ))}
                    </div>
                )}
            </div>

            {shouldCollapse && blocks.length > 0 && (
                <button
                    type="button"
                    className={styles.expandCollapse}
                    onClick={() => setExpanded((e) => !e)}
                    aria-expanded={expanded}
                    aria-controls={`protocol-blocks-${protocol._id}`}
                >
                    {expanded ? 'Collapse' : `Show all ${blockCount} blocks`}
                    <span className={styles.chevron} aria-hidden>{expanded ? '▲' : '▼'}</span>
                </button>
            )}
        </div>
    );
}

export default ProtocolRow;
